// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/financial-widget/financial-widget.less
// module id = 3352
// module chunks = 0